<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Banners ({{ banners.length || 0 }})</h5>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="onClickAddNewBanner"
              >
                +
              </button>
            </div>

            <div class="empty" v-if="banners.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped custom-table" v-else>
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Redirect Link</th>
                  <th scope="col">Image Url</th>
                  <th scope="col">Image</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="banner.id" v-for="banner in banners">
                  <th scope="row">{{ banner.id }}</th>
                  <td>{{ banner.name || "--" }}</td>
                  <td>{{ banner.redirect_link || "--" }}</td>
                  <td>{{ banner.img_url || "--" }}</td>
                  <td>
                    <img class="preview" :src="banner.img_url" alt="" />
                  </td>

                  <td style="display: grid; gap: 10px">
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      @click="onClickDeleteBanner(banner)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <create-banner-component
        v-if="showBannerCreationComponent"
        @success="bannerCreationSuccess"
        @fail="bannernCreationFailed"
        @cancel="bannerCreationCancelled"
      ></create-banner-component>

      <delete-item-modal
        :schemtics="bannerDeleteSchemetics"
        v-if="showDeleteBannerModal"
        @success="onBannerDeleteSuccess"
        @cancel="onBannerDeleteCancelled"
      ></delete-item-modal>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
var NotificationsController = require("../components/NotificationsController.js");
import CreateBannerComponent from "../components/CreateBannerComponent.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";

import moment from "moment";
export default {
  name: "Banners",
  components: {
    NavBar,
    CreateBannerComponent,
    DeleteItemModal,
  },
  data() {
    return {
      banners: [],
      showBannerCreationComponent: false,
      bannerDeleteSchemetics: {},
      showDeleteBannerModal: false,
    };
  },
  methods: {
    onBannerDeleteCancelled() {
      this.showDeleteBannerModal = false;
      this.bannerDeleteSchemetics = {};
    },
    onBannerDeleteSuccess() {
      this.showDeleteBannerModal = false;
      this.bannerDeleteSchemetics = {};
      this.getBanners();
    },
    onClickDeleteBanner(banner) {
      let access_level = localStorage.getItem("access_level");
      if (access_level != 1) {
        this.$toast.error(
          "Only banner with access level 1 can delete other banners"
        );
        return;
      }
      let url = URLS.BANNER.BY_ID.replace(":id", banner.id);
      this.bannerDeleteSchemetics = {
        endpoint: url,
        title: "Delete Banner",
        description: `Are you sure you want to delete <b> ${banner.name} </b> from the banners list ?`,
      };
      this.showDeleteBannerModal = true;
    },
    onClickAddNewBanner() {
      this.showBannerCreationComponent = true;
    },
    bannerCreationSuccess(res) {
      this.showBannerCreationComponent = false;
      this.getBanners();
    },
    bannerCreationCancelled() {
      this.showBannerCreationComponent = false;
    },
    getBanners() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.BANNER.LIST;
      HTTP.get(url)
        .then((response) => {
          let rows = response.data;
          ctx.banners = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getBanners();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.preview {
  width: 8rem;
  height: 4.5rem;
}
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    button {
      height: 3rem;
      font-size: 2rem;
      text-align: center;
      line-height: 1rem;
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;

  .input-group {
    display: flex;
    align-items: center;

    div {
      height: 100% !important;
    }

    input {
      height: 100% !important;
    }
  }

  .actions {
    margin-left: auto;
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    button {
      widows: 100px;
    }
  }
  // button{
  //   margin-left: 10px;
  // }
}
.actions {
  button {
    margin-right: 4px;
  }
}
</style>
